<template>
    <div class="player-score__results">
        <div class="caption">
            Player results at indian wells 2018
        </div>
        <div class="Results-matches">
            <score-card v-for="match in matches"
                        :match="match"
                        v-if="showMatch(match)"
                        :flagPath="flagPath"
                        :key="match.id"
                        :detail="detail"
                        mode="result"
                        :data-id="match.id">
            </score-card>

            <div class="na">
                <div class="na__title" style="margin-bottom: 0">
                    No matches so far
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import MatchCard from './MatchCard.vue'

    export default {
        components: {
            'score-card': MatchCard,
        },
        props: ['player', 'type', 'flag', 'detail'],
        data() {
            return {
                feed: [],
                matches: [],
                flagPath: this.flag + '/assets/dist/svg/flags/',
            }
        },
        created() {
            let ip = this.determineFeedUrl()

            axios.get(`${ip}/get/${this.type}/draws`).then(response => {

                let feed = response.data
                this.feed = response.data

                let allMatches = this.getAllMatchesInOneArray(feed)
                let finishedMatches = this.getOnlyFinishedMatches(allMatches)
                let playerMatches = this.getOnlyPlayerMatches(finishedMatches)

                this.matches = playerMatches.reverse()

            }).catch(function (error) {
                console.log(error);
            });
        },
        methods: {
            getOnlyFinishedMatches(matches) {
                return matches.filter(function(match) {

                    return match.detail.state == 'F'

                })

            },
            getOnlyPlayerMatches(matches) {

                return matches.filter(function (match) {

                    if (match.detail.idA == this || match.detail.idA2 == this || match.detail.idB == this || match.detail.idB2 == this) {
                        return match
                    }

                }, this.player)

            },
            getAllMatchesInOneArray(feed) {
                let allMatches = []

                for (let event of feed) {
                    for (let round of event.rounds) {
                        allMatches.push(...round.matches)
                    }
                }

                return allMatches
            },
            determineFeedUrl() {

                if (this.type == 'atp') {
                    return window.atp_ip
                } else {
                    return window.wta_ip
                }

            },
            getOnlyPlayerMatches(matches) {

                return matches.filter(function (match) {

                    if (match.detail.idA == this || match.detail.idA2 == this || match.detail.idB == this || match.detail.idB2 == this) {
                        return match
                    }

                }, this.player)

            },
            showMatch(match) {
                if (!match.detail) {
                    return false
                }

                if (match.detail.state == 'F') {
                    return true
                }
            }
        }
    }
</script>